import { render, staticRenderFns } from "./UpscaleJobCard.vue?vue&type=template&id=671a94fe&scoped=true"
import script from "./UpscaleJobCard.vue?vue&type=script&lang=js"
export * from "./UpscaleJobCard.vue?vue&type=script&lang=js"
import style0 from "./UpscaleJobCard.vue?vue&type=style&index=0&id=671a94fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671a94fe",
  null
  
)

export default component.exports